export enum ETabPreExaminationInfo {
  Clinic,
  UpdateBioStats,
  ServiceIndication
}
